module.exports = __webpack_public_path__ + "static/img/PattersonBenjamin_ParisPerformance2002_2.06774fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brecht/archive/PattersonBenjamin_ParisPerformance2002_2.jpg
// module id = 7xCA
// module chunks = 0